import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ordersComponent } from '../components/orders/orders.component';
import { draftOrdersComponent } from '../components/draft-order/draft-orders.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
    data: { title: 'Order List' }
  },
  {
    path: '',
    component: ordersComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Orders' }
  },
  {
    path: 'draft-order',
    component: draftOrdersComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Orders' }
  },

  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ordersRoutingModule { }
